import './tienda/app.css';
import { iniciar } from './tienda/app';

iniciar();
